const productEnum = {
    Geral: 1,
    Simplific: 2,
};

export default productEnum;
